import React from "react";
import {
  type BetaFeatures,
  getBetaFeatures,
  setBetaFeatures,
  subscribeToBetaFeatures,
} from "./betaFeatures.store";

/**
 * Reactive view of the beta features. The store caches its parsed snapshot, so
 * this stays stable between changes as `useSyncExternalStore` requires.
 */
export default function useBetaFeatures(): [BetaFeatures, (patch: Partial<BetaFeatures>) => void] {
  const features = React.useSyncExternalStore(subscribeToBetaFeatures, getBetaFeatures, () =>
    getBetaFeatures()
  );

  const update = React.useCallback((patch: Partial<BetaFeatures>) => {
    setBetaFeatures({ ...getBetaFeatures(), ...patch });
  }, []);

  return [features, update];
}
